<template>
  <div>
    <v-btn dark depressed @click.prevent="openModal">
      <v-icon class="me-2">mdi-plus</v-icon>
      Add Bag Colour
    </v-btn>

    <v-dialog v-model="modalVisible" persistent max-width="600px">
      <v-card>
        <v-card-title class="text-h5 mb-4">Add Bag Colour</v-card-title>

        <v-card-text>
          <v-form ref="form" @submit.prevent="attemptAddBagColour">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  label="Name"
                  :disabled="isSaving"
                  v-model="bagColour.name"
                  :rules="nameRules"
                  required
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="Group"
                  :disabled="isSaving"
                  v-model="bagColour.group"
                  :rules="groupRules"
                  required
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="isSaving"
            color="red darken-1"
            text
            @click="modalVisible = false"
          >
            Cancel
          </v-btn>
          <v-btn
            :disabled="isSaving"
            :loading="isSaving"
            color="primary darken-1"
            text
            @click="attemptAddBagColour"
          >
            Add Bag Colour
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Display from "../../../mixins/Display";
import Forms from "../../../mixins/Forms";
import bagColours from "../../../api/settings/bag-colours";
const _ = require("lodash");
export default {
  mixins: [Display, Forms],
  data() {
    return {
      modalVisible: false,
      isSaving: false,
      bagColour: {
        name: "",
        group: "",
      },

      nameRules: [(v) => !!v || "Name is required"],
      groupRules: [(v) => !!v || "Group is required"],
    };
  },
  methods: {
    openModal() {
      this.modalVisible = true;
    },

    resetForm() {
      this.bagColour = {
        name: "",
        group: "",
      };
    },

    attemptAddBagColour() {
      let isValid = this.$refs["form"].validate();
      if (isValid) {
        this.addBagColour();
      }
    },

    addBagColour() {
      let vm = this;
      vm.isSaving = true;

      let params = {
        name: this.bagColour.name,
        group: this.bagColour.group,
      };

      bagColours
        .store(params)
        .then((r) => {
          vm.isSaving = false;
          vm.$toast.success("Bag colour added successfully");
          vm.$emit("refresh");
          vm.modalVisible = false;
        })
        .catch((e) => {
          console.log(e);
          let errors = vm.getErrorsAsArray(e);
          vm.$toast.error(_.first(errors));
          vm.isSaving = false;
        });
    },
  },
};
</script>

<colour>
</colour>